<template>
    <general-input
        v-model="line.description"
        placeholder="Beskrivelse"
        data-cy="description-input"
    />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import GeneralInput from '@/components/GeneralInput.vue'

const line = defineModel<TransactionEntryLine>({required: true})

</script>

<style scoped>

</style>